export class FileMaterial {
    
    public id: string;
    public name: string;   
    public original: string;
    public storage: string;
    public url: string;

    constructor() {}
}